module.exports = __webpack_public_path__ + "img/eye-mature-3-water-metabolism.feac50d3.jpg";